module.exports = __webpack_public_path__ + "static/media/Klavika_Light.ab75eb60.woff";